import { useSelector, useDispatch } from 'react-redux';
import { toggleTimerPaused, resetTimer } from 'redux/slices';
import { Box, Button, Typography } from '@mui/material';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

// Só exibe e controla o cronômetro; a contagem roda no GameClock (global, em qualquer aba).
export function Counter() {
  const { time, timerPaused } = useSelector((state) => state.game);
  const dispatch = useDispatch();

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2,
    }}
    >
      <Typography variant="h4" textAlign="center">
        {`${time.minutes}m:${time.seconds < 10 ? '0' : ''}${time.seconds}s`}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <Button
          size="small"
          variant="outlined"
          color="secondary"
          startIcon={timerPaused ? <PlayArrowIcon /> : <PauseIcon />}
          onClick={() => dispatch(toggleTimerPaused())}
        >
          {timerPaused ? 'Retomar' : 'Pausar'}
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="warning"
          startIcon={<RestartAltIcon />}
          onClick={() => dispatch(resetTimer())}
        >
          Zerar cronômetro
        </Button>
      </Box>
    </Box>
  );
}
